import * as Sentry from "@sentry/react";
import { z } from "zod";
import { createLocalStore } from "../../../lib/store";

// Per browser and not per account (OD-08): an assistant composer shows the
// Input rule until the first Question leaves this browser.
const useInputRuleSeenStore = createLocalStore(
  "gpt-redaction-input-rule-seen-v1",
  false,
  z.boolean()
);

// A reminder only: a storage that refuses the write keeps the rule on screen and never blocks a send.
export function usePatientDataInputRuleSeen(): [boolean, () => void] {
  const [seen, setSeen] = useInputRuleSeenStore();
  return [
    seen,
    () => {
      try {
        setSeen(true);
      } catch (error) {
        Sentry.captureException(error);
      }
    },
  ];
}
